import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-436ec132"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bank_account" }
const _hoisted_2 = { key: 0 }

import ModelPersonBalance from "@/api/main/services/NaturalPersonProfile/models/response/GetNewUser/ModelPersonBalance";
import ModelPersonCard from "@/api/main/services/NaturalPersonProfile/models/response/GetNewUser/ModelPersonCard";
import ModelTypeCard from "@/api/main/services/NaturalPersonProfile/models/response/GetNewUser/ModelTypeCard";
import NaturalPersonModel from "@/views/models/NaturalPersonModel";

import { AdapterBalanceService } from "./adapter";
import { onMounted, ref } from "vue";
import ModelNaturalPerson from "@/api/main/dataSource/api/i-public-service/aba-finance/models/user/ModelNaturalPerson";
import { AdapterApiService } from '../_adapter';
import UserType from '@/api/main/models/Enums/UserType';


export default /*#__PURE__*/_defineComponent({
  __name: 'balance-page',
  setup(__props) {

const Profile = ref(new NaturalPersonModel());
// const ProfileToOrderCard: any = {};
const Cards = ref(Array<ModelPersonCard>());
const SelectCardId = ref("");
const Balance = ref(new ModelPersonBalance());
const IsOrderCard = ref(false);
const IsLoad = ref(true);

const refillVisible = ref(false);
const acquiringRefillVisible = ref(false);

// created() {
// 	this.setPerson();
// }
const adapter = AdapterBalanceService.getInstance();
// @Watch("$store.state.currentPersonProfile", { deep: true })
// function setPerson() {
// 	// if (this.$store.state.currentPersonProfile && !this.Profile) {
// 	Profile.value = adapter.toNaturalPerson(this.$store.state.currentPersonProfile);
// 	Cards.value = Profile.value.Cards;
// 	Balance.value = Profile.value.Balance;
// 	if (Cards.value && Cards.value[0]) SelectCardId.value = Cards[0].value.TrackNumber;
// 	setTestCard();
// 	// this.Profile.PaymentsType = 4;

// 	IsLoad.value = false;
// 	// }
// }

onMounted(async () => {
	
	if (AdapterApiService.getInstance().userInfo.value.UserRole == UserType.Natural) {
		await getNaturalProfile();
		return 
	}

	await getLegalProfile()
});

async function getNaturalProfile() {
	const res = await adapter.getNaturalPerson(); //ModelNaturalPerson
	if (res instanceof ModelNaturalPerson) {
		Profile.value = adapter.convertModelNaturalPersonToNaturalPersonModel(res);
		Cards.value = Profile.value.Cards;
		Balance.value = Profile.value.Balance;
		if (Cards.value && Cards.value[0]) SelectCardId.value = Cards[0].value.TrackNumber;
		setTestCard();
	}
}
async function getLegalProfile() {
	
	const res = 	await adapter.getLegalPerson(); //ModelNaturalPerson
	if (res.IsSuccess) {
		Profile.value = adapter.convertModelNaturalPersonToNaturalPersonModel(res.Value);
		Cards.value = Profile.value.Cards;
		Balance.value = new ModelPersonBalance( Profile.value.Balance);
		if (Cards.value && Cards.value[0]) SelectCardId.value = Cards[0].value.TrackNumber;
		setTestCard();
	}
}

function GetOrderCard() {
	console.log("GetOrderCard: РЕДИРЕКТ на заказ карты");
	// window.location.href = store.getters.generateUrl({
	//   Url: store.state.UrlOrderCardPage,
	//   Lang: store.state.LangSwither
	// });
}

function UpdateBalance(newBalance: number) {
	this.Balance.Balance = newBalance;
}

function openReplenish() {
	refillVisible.value = true;
}

function openReplenishAcquiring() {
	acquiringRefillVisible.value = true;
}

function setTestCard() {
	Cards.value.push(
		new ModelPersonCard({
			TrackNumber: "0000000",
			TypeCard: new ModelTypeCard({
				Id: 1,
				Name: "MyCard",
				Currency: 1,
				CurrencyName: "Da",
				LimitService: 0,
				TermService: new Date(),
				TermServiceJs: 1,
				Commission: 1,
			}),
			AddressCard: "home 12345",
		})
	);
}

return (_ctx: any,_cache: any) => {
  const _component_account_section = _resolveComponent("account-section")!
  const _component_refill = _resolveComponent("refill")!
  const _component_acquiring_refill = _resolveComponent("acquiring-refill")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_account_section, {
        balance: Balance.value,
        profile: Profile.value,
        onOpenReplenish: openReplenish,
        onOpenReplenishAcquiring: openReplenishAcquiring
      }, null, 8, ["balance", "profile"])
    ]),
    (Profile.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_refill, {
            visible: refillVisible.value,
            Balance: Balance.value,
            Profile: Profile.value,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (refillVisible.value = false))
          }, null, 8, ["visible", "Balance", "Profile"]),
          _createVNode(_component_acquiring_refill, {
            visible: acquiringRefillVisible.value,
            Balance: Balance.value,
            Profile: Profile.value,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (acquiringRefillVisible.value = false))
          }, null, 8, ["visible", "Balance", "Profile"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})